import { Modal } from "react-bootstrap";
import { Wrapper, Button } from "../styles";
import { useState, useContext, useEffect, useRef } from "react";
import { DataContext } from "../DataContext";
import toast from "react-hot-toast";
import { Tooltip } from "react-tooltip";
import { isAlphaNumeric, renderSizeOptions } from "../utils";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { getProductStock } from "../api/misc";
import Viewer360 from "../components/Viewer360";

const SelectionModal = ({ selectedDesign, setSelectedDesign, showModal, setShowModal }) => {
  const { addToCart } = useContext(DataContext);
  const navigate = useNavigate();

  const productId = "prod_OdiHceEPLy8W3Z";
  const [productStock, setProductStock] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [size, setSize] = useState("");
  const [position, setPosition] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);

  // component mount
  useEffect(() => {
    getProductStockFunc();
  }, []);

  const getProductStockFunc = async () => {
    try {
      const stock = await getProductStock(productId);
      setProductStock(stock);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  function handleCloseModal() {
    setSize(null);
    setPosition(null);
    setQuantity(1);
    setSelectedDesign(null);
    setShowModal(false);
    setShowConfirmation(false);
  }

  function handleClick(path) {
    navigate(path);
  }

  function handleAddMoreOfThisDesign() {
    setSize(null);
    setPosition(null);
    setQuantity(1);
    setShowConfirmation(false);
  }

  function validateForm() {
    if (!quantity || !size || !position) {
      return "all fields are required";
    } else if (!isAlphaNumeric([quantity, size, position])) {
      return "invalid field values";
    } else {
      return null;
    }
  }

  const formSubmit = async (e) => {
    e.preventDefault();
    const error = validateForm();
    if (!error) {
      addToCart(productId, quantity, {
        size,
        position,
        design: selectedDesign.designName,
      })
        .then(() => {
          setShowConfirmation(true);
        })
        .catch((error) => {
          console.error(error);
          toast.error(error.message);
        });
    } else {
      toast.error(error);
    }
  };

  const tooltipRef = useRef(null);

  const showTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.open();
    }
  };

  const hideTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.close();
    }
  };

  return (
    <Modal size="xl" fullscreen={"md-down"} show={showModal} animation={false} onHide={handleCloseModal}>
      <Wrapper className="modal-styles">
        {showConfirmation ? (
          <>
            <Modal.Header closeButton>
              <Modal.Title>Design was Added To Bag</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="box-padding">
                <Button tabIndex="0" className="stacked-button" onClick={handleAddMoreOfThisDesign}>
                  Add More Of This Design
                </Button>
                <Button className="stacked-button" onClick={handleCloseModal}>
                  Select Another Design
                </Button>
                <Button className="stacked-button" onClick={() => handleClick("/bag")}>
                  Go To Shopping Bag
                </Button>
              </div>
            </Modal.Body>
          </>
        ) : (
          <>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <>
                <div className="selectedDesignModal">
                  <div className="selected-design-image">
                    <Viewer360 position={position} selectedDesign={selectedDesign} />
                  </div>
                  <form onSubmit={formSubmit}>
                    <h2>
                      Shirt Options
                      <i
                        tabIndex={0}
                        data-tooltip-id="design-placement"
                        data-tooltip-place="bottom"
                        className="add-to-cart-info fa-solid fa-circle-info"
                        onFocus={showTooltip}
                        onBlur={hideTooltip}
                        aria-label="Shirt options information"
                        aria-describedby="design-placement"
                        role="button"
                      />
                    </h2>
                    <Form.Group className="form-group">
                      <Form.Select name="size" id="size" value={size} onChange={(e) => setSize(e.target.value)} aria-label="Shirt Size">
                        <option value="">Size</option>
                        {renderSizeOptions(productStock)}
                      </Form.Select>
                      <Form.Select name="position" id="position" value={position} onChange={(e) => setPosition(e.target.value)}>
                        <option value="">Position</option>
                        <option value="">-----</option>
                        <option value="Front">Front (Logo on Neck)</option>
                        <option value="Back">Back (Logo on Left Chest)</option>
                      </Form.Select>
                      <Form.Select name="quantity" id="quantity" value={quantity} onChange={(e) => setQuantity(e.target.value)}>
                        <option value="">Qty</option>
                        <option value="">-----</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                      </Form.Select>
                    </Form.Group>
                    <Button className="add-to-cart-button" type="submit">
                      add to shopping bag
                    </Button>
                  </form>
                </div>
              </>
            </Modal.Body>
          </>
        )}
        <Tooltip ref={tooltipRef} role="tooltip" id="design-placement" openOnClick={true}>
          <div className="content">
            <h3>Graphic Position</h3>
            <span>Design can be placed on front or back of shirt.</span>
            <span>Front design will have small logo on back of neck.</span>
            <span>Back design will have logo on left chest area.</span>
          </div>
        </Tooltip>
      </Wrapper>
    </Modal>
  );
};

export default SelectionModal;
